const replaceReg = /(?:(?:\d+|splits))\./g;

// Remove '.\d' | '.\d or splits'
function convertFieldIdToCol(fieldId: string) {
  return fieldId.replace(replaceReg, '');
}

export { convertFieldIdToCol };
